import React from 'react'

export default function SecureCompliant() {
   return (
      <svg
         width="60"
         height="60"
         viewBox="0 0 60 60"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clipPath="url(#clip0_5241_77807)">
            <path
               d="M21.6895 24.0488H26.4835V28.7871H21.6895V24.0488Z"
               fill="#1F473E"
            />
            <path
               d="M31.7587 0V16.8748H28.2415V0L6.61621 7.97671V33.1702C6.61621 42.2355 11.5275 50.6225 19.4334 55.0581L28.2415 60V40.7557H31.7587V60L40.5668 55.0581C48.4728 50.6225 53.384 42.2354 53.384 33.1702V7.97671L31.7587 0ZM30.001 37.1287H26.4838V32.3049H21.6897V37.1287H18.1724V20.5321H30.001V37.1287ZM33.5441 24.0494V20.5321H41.8278V24.0494H39.4446V33.6114H41.8278V37.1287H33.5441V33.6114H35.9273V24.0494H33.5441Z"
               fill="#1F473E"
            />
         </g>
         <defs>
            <clipPath id="clip0_5241_77807">
               <rect width="60" height="60" fill="white" />
            </clipPath>
         </defs>
      </svg>
   )
}
